//@flow
import React from 'react';

import {makeStyles} from '@material-ui/core/styles';
import {useCategories} from '../../../categories/utils';
import FilterButton from '../../../../elements/HorizontalFilter/FilterButton/FilterButton';
import {colors} from '../../../../assets/styles/colors';
import {useToggleFilter} from '../../utils/productFilters';
import TiendadaTooltip from '../../../../elements/tiendada-tooltip';

const useStyles = makeStyles(theme => ({
  filterItemContainer: {
    display: 'flex',

    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: '5px',
      height: '5px',
    },

    '&::-webkit-scrollbar-track': {
      background: colors.grey200,
      borderRadius: '5px',
    },

    '&::-webkit-scrollbar-thumb': {
      background: colors.grey400,
      borderRadius: '5px',
    },
  },
  categoriesContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '.5rem',
  },

  categoryDisabled: {
    opacity: 0.5,
  },
}));

export default function CategoryFilter() {
  const {filter, resetFilters, toggleFilterValue} = useToggleFilter();
  const categories = useCategories();

  const classes = useStyles();

  return (
    <div className={classes.filterItemContainer}>
      <div className={classes.categoriesContainer}>
        <FilterButton
          id="all"
          handleOnClick={resetFilters}
          selected={filter.value.length === 0}
          text="todos"
        />

        {categories &&
          categories.map((category, index: number) => (
            <TiendadaTooltip
              key={category.id}
              title={'Esta categoría está deshabilitada'}
              disableHoverListener={category.enabled}
              placement="top"
            >
              <div>
                <FilterButton
                  selected={filter.value.includes(category.id)}
                  id={category.id}
                  handleOnClick={() => {
                    toggleFilterValue(category.id);
                  }}
                  classes={{
                    root: category.enabled ? '' : classes.categoryDisabled,
                  }}
                  text={category.name}
                />
              </div>
            </TiendadaTooltip>
          ))}
      </div>
    </div>
  );
}
